export default "__VITE_ASSET__DKxj4cKW__"